import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <RankingSection />
        <UpdatesSection />
        <CarouselSection />
        <FeaturesSection />
        <MediaSection />
        <CommentsSection />
        <CardsSection />
        <IndexSection />
        <AppSection />
        <ContactSection />
        <FaqSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}